export default {
  NODE_ENV: "production",
  API_URL: "https://tg.ip.zvonobot.ru/api",
  TG_BOT_URL: "https://t.me/Virtual_PBX_bot"
};
